import { render, staticRenderFns } from "./SixNumber.vue?vue&type=template&id=64e4f54a&"
import script from "./SixNumber.vue?vue&type=script&lang=js&"
export * from "./SixNumber.vue?vue&type=script&lang=js&"
import style0 from "./SixNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports